import React, { ReactElement } from "react";
import { CheckCircle } from "@untitled-ui/icons-react";
import styles from "./singleBenefit.module.scss";
import classNames from "classnames";

export const SingleBenefit = (props: Props): ReactElement => {
  return (
    <div
      className={classNames({
        [styles.reverseContainer]: props.order % 2 == 1,
        [styles.container]: props.order % 2 == 0,
      })}
      id={props.anchor_tag}
    >
      <div className={styles.content}>
        <div className={styles.headingAndSupportingText}>
          <h3 className={styles.title}>{props.title}</h3>
          <p className={styles.supportText}>{props.description}</p>
        </div>

        <div className={styles.checkItems}>
          {props.bullets?.map((b, i) => (
            <p key={i} className={styles.checkItemText}>
              <CheckCircle
                className={classNames({
                  [styles.blueIcon]: props.theme == "blue",
                  [styles.greenIcon]: props.theme == "green",
                })}
                viewBox="0 0 24 24"
              />
              {b}
            </p>
          ))}
        </div>
      </div>
      <div className={styles.imageContainer}>
        <img
          src={props.imageUrl}
          alt={props.title}
          className={styles.image}
          loading="lazy"
        />
      </div>
    </div>
  );
};

interface Props {
  order: number;
  imageUrl: string;
  title: string;
  description: string;
  bullets: string[];
  theme: "blue" | "green";
  anchor_tag?: string;
}
